<fieldset>
  <h4 i18n>Order Rows&nbsp;-&nbsp;<span>Total:&nbsp;</span><span>{{ total$ | async  | currency:'EUR' }}</span></h4>
  
  <div *ngIf="itemsFormArray.hasError('minSum')">
    You must buy a total sum of at least {{ itemsFormArray.getError('minSum') }}.
  </div>
  <div class="order-entry-list">
    <app-order-entry-control *ngFor="let item of itemsFormArray.controls; let i=index"  [index]="i" 
    [item]="item" [isInvoicesAndDdt]="isInvoicesAndDdt" (removed)="itemsFormArray.removeAt($event)">
    </app-order-entry-control>
  </div>
  <button mat-fab color="accent" (click)="addItem()">
    <mat-icon>add</mat-icon>
  </button>
</fieldset>



// WEBPACK FOOTER //
// ./src/app/order/components/order-entry-array.component.html